import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Card,
  CardBody,
  Flex,
  Stack,
  VStack,
} from '@chakra-ui/react';
import { OrderWithDeliveryOrders } from '@diamond/shared/types';
import { Heading, Icon, Text } from '@diamond/shared/ui';
import { SOStatus } from '@diamond/sol-buyer/constant';

import { OrderStatusTruckIconOutline } from '../icons';
import { OrderRow } from './OrderRow';
import {
  OrderDetailStatusByDivision,
  OrderDetailStatusByOrderId,
  OrderItemQuantityMetaMap,
} from './types';

export interface OrderStatusProps {
  orders: OrderWithDeliveryOrders[];
  distributionChannel?: string;
  orderDetailStatusByDivision: OrderDetailStatusByDivision;
  orderDetailStatusByOrderId?: OrderDetailStatusByOrderId;
  orderItemMetaById?: OrderItemQuantityMetaMap;
  overrideStatus?: SOStatus;
  overrideReason?: string;
  showDetails?: boolean;
  renderDivisionDetails?: boolean;
}

export function OrderStatus({
  orders,
  distributionChannel,
  orderDetailStatusByDivision,
  orderDetailStatusByOrderId,
  orderItemMetaById,
  overrideStatus,
  overrideReason,
  showDetails = true,
  renderDivisionDetails = false,
}: OrderStatusProps) {
  if (!orders || orders.length === 0) {
    return null;
  }

  return (
    <Card
      shadow="none"
      borderRadius="8px"
      borderWidth="1px"
      borderColor="#D9D9D9"
      mt="60px"
    >
      <CardBody p={0}>
        <Accordion allowToggle defaultIndex={[0]}>
          <AccordionItem border="none">
            <AccordionButton
              w={{ base: '100%', md: '378px' }}
              h="80px"
              p="24px"
              _hover={{ bg: 'gray.50' }}
              data-testid="accordion-button-order-status"
            >
              <Flex alignItems="center" gap="2" flex={1}>
                <Icon
                  as={OrderStatusTruckIconOutline}
                  color="#0000A3"
                  boxSize="32px"
                />
                <Heading fontSize={{ base: 'lg', md: 'xl' }} fontWeight="600">
                  Status Pesanan
                </Heading>
              </Flex>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel
              px={{ base: 3, md: 4 }}
              pb={{ base: 3, md: 4 }}
              pt={0}
            >
              <Stack spacing={{ base: 0, md: 2 }}>
                {/* Subtitle */}
                <Text
                  fontSize={{ base: 'xs', md: 'sm' }}
                  color="gray.500"
                  mb={{ base: 1, md: 2 }}
                >
                  Dikirim dengan truk sesuai cara penyimpanan produk
                </Text>

                {/* Order List */}
                {!showDetails ? (
                  <VStack align="stretch" spacing={2}>
                    {orders.map((order) => (
                      <OrderRow
                        key={order.order_id}
                        order={order}
                        distributionChannel={distributionChannel}
                        orderDetailStatusByDivision={
                          orderDetailStatusByDivision
                        }
                        orderDetailStatusByOrderId={orderDetailStatusByOrderId}
                        showDetails={false}
                        renderInlineDetails={renderDivisionDetails}
                        overrideStatus={overrideStatus}
                        overrideReason={overrideReason}
                        orderItemMetaById={orderItemMetaById}
                      />
                    ))}
                  </VStack>
                ) : (
                  <Accordion allowMultiple>
                    {orders.map((order) => (
                      <OrderRow
                        key={order.order_id}
                        order={order}
                        distributionChannel={distributionChannel}
                        orderDetailStatusByDivision={
                          orderDetailStatusByDivision
                        }
                        orderDetailStatusByOrderId={orderDetailStatusByOrderId}
                        overrideStatus={overrideStatus}
                        overrideReason={overrideReason}
                        orderItemMetaById={orderItemMetaById}
                      />
                    ))}
                  </Accordion>
                )}
              </Stack>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </CardBody>
    </Card>
  );
}

export default OrderStatus;
